import { Component, OnInit } from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';

@Component({
    standalone: false,
    selector: 'particle-footnote-dialog',
  templateUrl: './footnote-dialog.component.html',
  styleUrls: ['./footnote-dialog.component.scss']
})
export class FootnoteDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  constructor(public router: Router,
              public dialog: MatDialog) { }

  ngOnInit() {
  }

  onOkClicked(): boolean {
    return true;
  }
}
